<template>
	<div>
		<div class="d-none">
			<div ref="pdf_content">
				<table cellspacing="0" cellpadding="0"
					style="font-family:Arial; width:525.75pt; margin-right:auto; margin-left:auto; border:0.75pt solid #ffffff; border-collapse:collapse;">
					<tbody>
						<tr>
							<td width="80%"
								style="border-right:1.5pt solid #2c246d; padding:0.75pt 8.25pt 0.75pt 0.38pt; vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; font-size:10pt; line-height: 13pt;">
									<strong>FINTOS CAPITAL SDN. BHD.</strong>
									<span style="font-size:13.5pt;">&nbsp;198401014613 (127169-T)</span><br>
									<strong><em><span>(Formerly known as Invinity Credit Sdn. Bhd.)</span></em></strong><br>
									<span>Puchong Financial Corporate Centre, Lot No. 11F-2, 11th Floor,</span><br>
									<span>Tower 4 @ PFCC, Jalan Puteri 1/2, Bandar Puteri, 47160 Puchong, Selangor.</span><br>
									<strong><span style="color:#2dbe7a;">Tel (O)</span></strong>
									<span style="color:#2dbe7a;">&nbsp;</span>
									<span>03-8080 9777 (Press No.4) |&nbsp;</span>
									<strong><span style="color:#2dbe7a;">(M)</span></strong>
									<strong><span> </span></strong>
									<span>+6012-347 9128&nbsp;</span><br><span>General Email: enquiryfintoscapital@fintos.com.my</span>
								</p>
							</td>
							<td style="vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; line-height:150%; font-size:10pt;"><img
										:src="base64Logo"
										width="192" height="75" alt=""></p>
							</td>
						</tr>
					</tbody>
				</table>
				<div id="doc_repayment_export">
					<h3 style="text-align:center; margin: 10px auto;">Repayment Schedule</h3>
					<table border=0 cellpadding=0 cellspacing=0 width="95%">
						<tr>
							<td style="width: 110px;">Customer Name</td>
							<td>:</td>
							<td style="width: 250px;">{{ _gHlp.getValue(activeCustomer, 'name', '-') }}</td>
							<td></td>
							<td>Loan Amount</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(_gHlp.getValue(activeCase, 'loan_amount', '0')) }}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>Our Ref</td>
							<td>:</td>
							<td>{{ _gHlp.getValue(activeCase, 'case_no', '-') }}</td>
							<td></td>
							<td>Total Interest</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(this.total_interest) }}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>Loan Tenure (year)</td>
							<td>:</td>
							<td>{{ loan_tenure_year }}</td>
							<td></td>
							<td>Total Repayment</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(this.total_repayment) }}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>Loan Tenure (months)</td>
							<td>:</td>
							<td>{{ loan_tenure_month }}</td>
							<td></td>
							<td>Monthly Instalment (p.m)</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(_gHlp.getValue(activeCase, 'installment_amount', '0')) }}</td>
							<td></td>
							<td></td>
						</tr>
					</table>
					<br />
					<table border=0 cellpadding=0 cellspacing=0 width="95%">
						<thead>
							<tr class="hed">
								<th>Instalment Month</th>
								<!-- <th>Sts</th> -->
								<th>Due Date</th>
								<th>Repayment Amt.</th>
								<th>Principal</th>
								<th>Interest</th>
								<!-- <th>Accum. Month</th> -->
								<th>Late Charges</th>
								<th>Balance</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(data, index) in tableData" :key="index" :class="index % 2 === 0 ? 'even' : 'odd'">
								<td>Continuance {{ data.instalment_mth }}</td>
								<!-- <td>{{ data.paid_status }}</td> -->
								<td>{{ _gHlp.formatMomentDate(data.due_date, 'D MMM, YYYY') }}</td>
								<td>{{ data.repayment_amt | moneyFormatter }}</td>
								<td>{{ data.principal_amt | moneyFormatter }}</td>
								<td>{{ data.interest_amt | moneyFormatter }}</td>
								<!-- <td class="text-right">{{ data.accumulate_mth }}</td> -->
								<td>{{ data.late_charge_amt | moneyFormatter }}</td>
								<td>{{ data.balance_amt | moneyFormatter }}</td>
							</tr>
						</tbody>
						<tfoot>
							<tr class="bg-info">
								<td colspan="2"><strong>Total</strong></td>
								<td><strong>{{ total_repayment | moneyFormatter }} </strong></td>
								<td><strong>{{ total_principal | moneyFormatter }} </strong></td>
								<td><strong>{{ total_interest | moneyFormatter }} </strong></td>
								<!-- <td></td> -->
								<td><strong>{{ total_late_charge | moneyFormatter }} </strong></td>
								<td><strong>{{ 0 | moneyFormatter }} </strong></td>
							</tr>
						</tfoot>
					</table>
				</div>

			</div>
		</div>
		<div class="preview">
			<modal :show.sync="is_visible" :hide-footer="true" bodyClasses="preview-modal">
				<div class="text-center">
					<iframe v-if="!_gHlp.isEmpty(pdfUrl)" :src="pdfUrl" class="iframe-preview w-100"></iframe>
				</div>
			</modal>
		</div>
	</div>
</template>

<style>
#doc_repayment_export {
	width: 100%;
	page-break-inside: auto;
}

#doc_repayment_export table {
	border: none;
	border-collapse: collapse;
	margin: 0 auto;
}

#doc_repayment_export tr {
	page-break-inside: avoid;
}
#doc_repayment_export th,td {
	border: none;
	padding: 8px;
	word-wrap: break-word;
  overflow-wrap: break-word;
}

#doc_repayment_export td {
	padding: 2px;
	color: black;
	font-size: 9.0pt;
	font-weight: 300;
	font-style: normal;
	text-decoration: none;
	text-align: general;
	vertical-align: bottom;
	border: none;
	white-space: nowrap;
	border: none;
}

#doc_repayment_export .hed th {
	padding: 2px;
	background: #26A69A;
	font-size: 9.0pt;
	font-weight:400;
}

#doc_repayment_export .odd td {
	background: #DDF2F0;
}

#doc_repayment_export .even td {
	background: #f7fcfb;
}
</style>

<script>
import { cloneDeep } from 'lodash'
import ExcelJS from 'exceljs';
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	data() {
		return {
			// Add your component data here
			pdfUrl: null,
			is_visible: false,
			tableData: [],
			base64Logo: ''
		};
	},
	async created() {
		this.base64Logo = await _gFile.getContentUrl('https://fintos-public.s3.ap-southeast-1.amazonaws.com/fintos_capital.jpg')
		// Add your created lifecycle hook here
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer', 'activeLoanEC']),
		...mapState(useLoanCaseStore, ['activeCase']),
		total_repayment() {
			if (_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.repayment_amt), 0);
		},
		total_principal() {
			if (_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.principal_amt), 0);
		},
		total_interest() {
			if (_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.interest_amt), 0);
		},
		total_late_charge() {
			if (_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.late_charge_amt), 0);
		},
		total_balance() {
			if (_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.balance_amt), 0);
		},
		loan_tenure_year(){
			let y = _gHlp.getValue(this.activeCase, 'loan_tenure', 1);
			return _gHlp.getValue(this.activeCase, 'loan_tenure_period', '') == 'Years' ?  y : (y / 12).toFixed(2);
		},
		loan_tenure_month(){
			return this.loan_tenure_year * 12;
		}
	},
	watch: {
		'pdfUrl': {
			handler(newValue, oldValue) {
				if (newValue) {
					console.log(newValue);
				}
			},
			immediate: true
		},
	},
	methods: {
		async show(data = []) {
			this.tableData = cloneDeep(data);
			await this.initPDF();
		},
		async initPDF() {
			// Capture the rendered HTML of the component (inside the `content` div)
			const content = this.$refs.pdf_content;
			this.pdfUrl = await _gFile.htmlToPdfUrl(content, 'Repayment_Schedule_'+_gHlp.getValue(this.activeCase, 'case_id', '')+'_'+_gHlp.getCurrentDateTime(false)+'.pdf');
			this.is_visible = true;

		},
		exportToExcel(data = []) {
			this.tableData = cloneDeep(data);

			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Repayment Schedule', { views: [{ showGridLines: false }] });
			const defaultFont = { name: 'Calibri', size: 12 };
			const defaultFontBold = { name: 'Calibri', size: 12, bold: true };
			const blankRow = { col_a: '', col_b: '', col_c: '', col_d: '', col_e: '', col_f: '', col_g: '', col_h: '', col_i: '', col_j: '' }

			//SETUP
			worksheet.columns = [{ key: 'col_a', width: 22.00 }, { key: 'col_b', width: 1 }, { key: 'col_c', width: 17.33 }, { key: 'col_d', width: 17.33 }, { key: 'col_e', width: 19.83 }, { key: 'col_f', width: 17.33 }, { key: 'col_g', width: 1 }, { key: 'col_h', width: 17.33 }, { key: 'col_i', width: 17.33 }, { key: 'col_j', width: 17.33 }];

			//HEADER
			worksheet.getCell('E1').value = { richText: [{ text: 'FINTOS CAPITAL SDN. BHD. ', font: { name: 'Calibri', size: 19, bold: true } }, { text: '198401014613 (127169-T)', font: { name: 'Calibri', size: 12 } }] };
			worksheet.getCell('E1').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('E2').value = '(Formerly known as Invinity Credit Sdn. Bhd.)';
			worksheet.getCell('E2').font = { name: 'Calibri', size: 12, bold: true, italic: true };
			worksheet.getCell('E2').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('E3').value = 'Puchong Financial Corporate Centre, Lot No. 11F-2, 11th Floor,';
			worksheet.getCell('E3').font = defaultFont;
			worksheet.getCell('E3').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('E4').value = 'Tower 4 @ PFCC, Jalan Puteri 1/2, Bandar Puteri, 47160 Puchong, Selangor.';
			worksheet.getCell('E4').font = defaultFont;;
			worksheet.getCell('E4').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('E5').value = {
				richText: [
					{ text: 'Tel: ', font: { name: 'Calibri', size: 12 } },
					{ text: '(O)', font: { name: 'Calibri', size: 12, bold: true, color: { argb: '80D09C' } } },
					{ text: ' 03-8080 9777 (Press No.4) | ', font: { name: 'Calibri', size: 12 } },
					{ text: '(M)', font: { name: 'Calibri', size: 12, bold: true, color: { argb: '80D09C' } } },
					{ text: ' +6012-347 9128', font: { name: 'Calibri', size: 12 } }
				]
			};
			worksheet.getCell('E5').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('E6').value = 'General Email: enquiryfintoscapital@fintos.com.my';
			worksheet.getCell('E6').font = defaultFont;
			worksheet.getCell('E6').alignment = { vertical: 'top', horizontal: 'right' };
			// Add header logo
			const imageId = workbook.addImage({
				base64: this.base64Logo, // Add your base64 image data here
				extension: 'jpg',
			});
			worksheet.addImage(imageId, 'F1:H6');

			//CONTENT
			//INFORMATIONS
			worksheet.getCell('A8').value = 'Repayment Schedule';
			worksheet.getCell('A8').font = { bold: true, size: 15 };
			worksheet.mergeCells('A8:I8');

			let profileSummary = [
				{ label: 'Customer Name', value: _gHlp.getValue(this.activeCase, 'name', ''), label_2: 'Loan Amount', value_2: 'RM ' + _gHlp.formatToMoney(_gHlp.getValue(this.activeCase, 'loan_amount', 0)) },
				{ label: 'Our Ref', value: _gHlp.getValue(this.activeCase, 'case_no', ''), label_2: 'Total Interest', value_2: 'RM ' + _gHlp.formatToMoney(this.total_interest) },
				{ label: 'Loan Tenure (Year)', value: this.loan_tenure_year, label_2: 'Total Repayment', value_2: 'RM ' + _gHlp.formatToMoney(this.total_repayment) },
				{ label: 'Loan Tenure (Month)', value: this.loan_tenure_month, label_2: 'Monthly Installment (p.m)', value_2: 'RM ' + _gHlp.formatToMoney(_gHlp.getValue(this.activeCase, 'installment_amount', 0)) }
			];

			profileSummary.forEach((item, index) => {
				const row = worksheet.addRow({
					col_a: item.label,
					col_b: ':',
					col_c: `${item.value}`,
					col_d: '',
					col_e: '',
					col_f: item.label_2,
					col_g: ':',
					col_h: `${item.value_2}`
				});
			});
			worksheet.addRow(blankRow);
			worksheet.addRow(blankRow);
			//REPAYMENT TABLE
			//-REPAYMENT TABLE HEADER
			const rowHeader = worksheet.addRow({
				col_a: 'Instalment MOnth',
				col_b: '',
				col_c: 'Due Date',
				col_d: 'Repayment AMount',
				col_e: 'Principal',
				col_f: 'Interest',
				col_g: '',
				col_h: 'Late Charges',
				col_i: 'Balance'
			});
			rowHeader.eachCell((cell) => {
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: '80D09C' }
				};
				cell.font = defaultFont
			});

			//-REPAYMENT TABLE BODY
			this.tableData.forEach((item, index) => {
				const row = worksheet.addRow({
					col_a: 'Continuance '+item.instalment_mth,
					col_b: '',
					col_c: _gHlp.formatMomentDate(item.due_date, 'D MMM, YYYY'),
					col_d: _gHlp.formatToMoney(item.repayment_amt),
					col_e: _gHlp.formatToMoney(item.principal_amt),
					col_f: _gHlp.formatToMoney(item.interest_amt),
					col_g: '',
					col_h: _gHlp.formatToMoney(item.late_charge_amt || 0),
					col_i: _gHlp.formatToMoney(item.balance_amt)
				});
				// Merge cells for Description column
				const rowIndex = row.number;
				if (worksheet.rowCount % 2 === 0) {
					row.eachCell((cell) => {
						cell.fill = {
							type: 'pattern',
							pattern: 'solid',
							fgColor: { argb: 'E8F6EE' }
						};
						cell.font = defaultFont
					});
				}
				worksheet.getCell('A' + rowIndex).font = defaultFontBold;
				worksheet.getCell('I' + rowIndex).font = defaultFontBold;
			});

			//-REPAYMENT TABLE FOOTER
			// console.log([this.total_credit,this.total_debit,this.total_balance, (this.total_credit - this.total_debit) ]);
			const rowTotal = worksheet.addRow({
				col_a: '',
				col_b: '',
				col_c: 'Total / Balance',
				col_d: _gHlp.formatToMoney(this.total_repayment),
				col_e: _gHlp.formatToMoney(this.total_principal),
				col_f: _gHlp.formatToMoney(this.total_interest),
				col_g: '',
				col_h: _gHlp.formatToMoney(this.total_late_charge || 0),
				col_i: _gHlp.formatToMoney(0)
			});
			rowTotal.eachCell((cell) => {
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'A1CDCE' }
				};
				cell.font = defaultFontBold
			});
			//END:REPAYMENT TABLE

			// download
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = 'Repayment_Schedule_'+_gHlp.getValue(this.activeCase, 'case_id', '')+'_'+_gHlp.getCurrentDateTime(false)+'.xlsx';
				link.click();
			});

		}
	},
	// Add your computed properties here
};
</script>
